import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
export var isString = function isString(value) {
  return value != null && value.constructor === String;
};
export function readJSONOrText(_x) {
  return _readJSONOrText.apply(this, arguments);
}

function _readJSONOrText() {
  _readJSONOrText = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
    var textData;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return response.text();

          case 2:
            textData = _context.sent;
            _context.prev = 3;
            return _context.abrupt("return", JSON.parse(textData));

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](3);
            return _context.abrupt("return", textData);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[3, 7]]);
  }));
  return _readJSONOrText.apply(this, arguments);
}
//# sourceMappingURL=utils.js.map